import * as React from 'react';

const SvgNote = (props) => (
  <svg
    width={56}
    height={56}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M36.867 5.157c-.957-.957-2.614-.304-2.614 1.026v8.144c0 3.406 2.894 6.23 6.417 6.23 2.217.023 5.297.023 7.933.023 1.33 0 2.03-1.563 1.097-2.497C46.34 14.7 40.32 8.61 36.867 5.157Z'
      fill='#E00034'
    />
    <path
      d='M47.834 23.777H41.09c-5.53 0-10.033-4.504-10.033-10.034V7a2.34 2.34 0 0 0-2.333-2.333H18.83c-7.186 0-12.996 4.666-12.996 12.996v20.674c0 8.33 5.81 12.996 12.996 12.996h18.34c7.187 0 12.997-4.666 12.997-12.996V26.11a2.34 2.34 0 0 0-2.334-2.333Zm-21 17.64H17.5c-.956 0-1.75-.794-1.75-1.75 0-.957.794-1.75 1.75-1.75h9.334c.956 0 1.75.793 1.75 1.75 0 .956-.794 1.75-1.75 1.75Zm4.666-9.334h-14c-.956 0-1.75-.793-1.75-1.75 0-.956.794-1.75 1.75-1.75h14c.957 0 1.75.794 1.75 1.75 0 .957-.793 1.75-1.75 1.75Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgNote;
